import type React from 'react';

import { useTranslation } from 'react-i18next';

import { useAppState } from '../../../../AppStateProvider';
import { useIsInternalDomain } from '../../../../hooks/useIsInternalDomain';
import {
  StyledMeetingDate,
  StyledMeetingDateSeparator,
  StyledMeetingInternalText,
  StyledMeetingTitle,
} from '../styles';

export const MultipleDomainsMeeting: React.FC = () => {
  const { collectedMeeting } = useAppState();
  const isInternalMeeting = useIsInternalDomain(collectedMeeting?.domains ?? []);
  const { t } = useTranslation();

  const [meetingDate, meetingTime] = (collectedMeeting?.time || '').split('⋅');

  return (
    <>
      <StyledMeetingTitle data-automation="MeetingTitle">{collectedMeeting?.title}</StyledMeetingTitle>
      <StyledMeetingDate data-automation="MeetingDate">
        {meetingDate}
        {meetingTime ? (
          <>
            <StyledMeetingDateSeparator />
            {meetingTime}
          </>
        ) : null}
      </StyledMeetingDate>
      {isInternalMeeting ? (
        <StyledMeetingInternalText>{t('meeting.internal_meeting')}</StyledMeetingInternalText>
      ) : null}
    </>
  );
};
